/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIException } from '../model';
// @ts-ignore
import { ConfirmationAcceptedPublic } from '../model';
// @ts-ignore
import { ConfirmationPublicCreateMediaRequest } from '../model';
// @ts-ignore
import { ConfirmationPublicMediaRead } from '../model';
// @ts-ignore
import { ConfirmationPublicMediaSignatureRequest } from '../model';
// @ts-ignore
import { ConfirmationRecipientPublic } from '../model';
// @ts-ignore
import { MediaSignature } from '../model';
// @ts-ignore
import { PublicConfirmationRecipientAcceptRequest } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * PublicBookingConfirmationApi - axios parameter creator
 * @export
 */
export const PublicBookingConfirmationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Acceptance can only occur when the Confirmation is the latest for the Booking and the status of the Confirmation is OPEN. If theres any issue when accepting the Confirmation the message for why will be returned in the `detail` key in the body.  An org id can be passed through which will create a linked Booking on the Org. Once this is set on a Booking via any of the Confirmation acceptances, it cannot be set again. time for any Confirm  The returned content will be a link to open the users SMS app with the recipient being the Confirmation owner and the content from the `booking_confirmation_accepted_sms` template.
         * @summary Accepts the Booking
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PublicConfirmationRecipientAcceptRequest} [publicConfirmationRecipientAcceptRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingConfirmationApproveCreate: async (recipientId: string, aaSource?: string, publicConfirmationRecipientAcceptRequest?: PublicConfirmationRecipientAcceptRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('publicBookingConfirmationApproveCreate', 'recipientId', recipientId)
            const localVarPath = `/v2/public/booking/confirmation/{recipient_id}/approve`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publicConfirmationRecipientAcceptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Declining a Confirmation can only occur when the Confirmation is the latest for the Booking and the status of the Confirmation is OPEN.  If theres any issue when accepting the Confirmation the message for why will be returned in the `detail` key in the body.
         * @summary Declines the Booking
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingConfirmationDeclineCreate: async (recipientId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('publicBookingConfirmationDeclineCreate', 'recipientId', recipientId)
            const localVarPath = `/v2/public/booking/confirmation/{recipient_id}/decline`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads media against the Confirmation
         * @param {string} recipientId 
         * @param {ConfirmationPublicCreateMediaRequest} confirmationPublicCreateMediaRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingConfirmationMediaCreate: async (recipientId: string, confirmationPublicCreateMediaRequest: ConfirmationPublicCreateMediaRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('publicBookingConfirmationMediaCreate', 'recipientId', recipientId)
            // verify required parameter 'confirmationPublicCreateMediaRequest' is not null or undefined
            assertParamExists('publicBookingConfirmationMediaCreate', 'confirmationPublicCreateMediaRequest', confirmationPublicCreateMediaRequest)
            const localVarPath = `/v2/public/booking/confirmation/{recipient_id}/media`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmationPublicCreateMediaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates a signature to allow content to be uploaded to Cloudinary directly
         * @param {string} recipientId 
         * @param {ConfirmationPublicMediaSignatureRequest} confirmationPublicMediaSignatureRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingConfirmationMediaSignatureCreate: async (recipientId: string, confirmationPublicMediaSignatureRequest: ConfirmationPublicMediaSignatureRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('publicBookingConfirmationMediaSignatureCreate', 'recipientId', recipientId)
            // verify required parameter 'confirmationPublicMediaSignatureRequest' is not null or undefined
            assertParamExists('publicBookingConfirmationMediaSignatureCreate', 'confirmationPublicMediaSignatureRequest', confirmationPublicMediaSignatureRequest)
            const localVarPath = `/v2/public/booking/confirmation/{recipient_id}/media/signature`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmationPublicMediaSignatureRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * `settings.orgs` contains a list of Organisations the Contact is an APPROVED member of. These can be used to assign and Org to the Confirmation on acceptance. 
         * @summary Fetch the public information about the Booking Confirmation
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingConfirmationRetrieve: async (recipientId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'recipientId' is not null or undefined
            assertParamExists('publicBookingConfirmationRetrieve', 'recipientId', recipientId)
            const localVarPath = `/v2/public/booking/confirmation/{recipient_id}`
                .replace(`{${"recipient_id"}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicBookingConfirmationApi - functional programming interface
 * @export
 */
export const PublicBookingConfirmationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicBookingConfirmationApiAxiosParamCreator(configuration)
    return {
        /**
         * Acceptance can only occur when the Confirmation is the latest for the Booking and the status of the Confirmation is OPEN. If theres any issue when accepting the Confirmation the message for why will be returned in the `detail` key in the body.  An org id can be passed through which will create a linked Booking on the Org. Once this is set on a Booking via any of the Confirmation acceptances, it cannot be set again. time for any Confirm  The returned content will be a link to open the users SMS app with the recipient being the Confirmation owner and the content from the `booking_confirmation_accepted_sms` template.
         * @summary Accepts the Booking
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PublicConfirmationRecipientAcceptRequest} [publicConfirmationRecipientAcceptRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBookingConfirmationApproveCreate(recipientId: string, aaSource?: string, publicConfirmationRecipientAcceptRequest?: PublicConfirmationRecipientAcceptRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmationAcceptedPublic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBookingConfirmationApproveCreate(recipientId, aaSource, publicConfirmationRecipientAcceptRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Declining a Confirmation can only occur when the Confirmation is the latest for the Booking and the status of the Confirmation is OPEN.  If theres any issue when accepting the Confirmation the message for why will be returned in the `detail` key in the body.
         * @summary Declines the Booking
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBookingConfirmationDeclineCreate(recipientId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmationRecipientPublic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBookingConfirmationDeclineCreate(recipientId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Uploads media against the Confirmation
         * @param {string} recipientId 
         * @param {ConfirmationPublicCreateMediaRequest} confirmationPublicCreateMediaRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBookingConfirmationMediaCreate(recipientId: string, confirmationPublicCreateMediaRequest: ConfirmationPublicCreateMediaRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmationPublicMediaRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBookingConfirmationMediaCreate(recipientId, confirmationPublicCreateMediaRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generates a signature to allow content to be uploaded to Cloudinary directly
         * @param {string} recipientId 
         * @param {ConfirmationPublicMediaSignatureRequest} confirmationPublicMediaSignatureRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBookingConfirmationMediaSignatureCreate(recipientId: string, confirmationPublicMediaSignatureRequest: ConfirmationPublicMediaSignatureRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaSignature>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBookingConfirmationMediaSignatureCreate(recipientId, confirmationPublicMediaSignatureRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * `settings.orgs` contains a list of Organisations the Contact is an APPROVED member of. These can be used to assign and Org to the Confirmation on acceptance. 
         * @summary Fetch the public information about the Booking Confirmation
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicBookingConfirmationRetrieve(recipientId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmationRecipientPublic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicBookingConfirmationRetrieve(recipientId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicBookingConfirmationApi - factory interface
 * @export
 */
export const PublicBookingConfirmationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicBookingConfirmationApiFp(configuration)
    return {
        /**
         * Acceptance can only occur when the Confirmation is the latest for the Booking and the status of the Confirmation is OPEN. If theres any issue when accepting the Confirmation the message for why will be returned in the `detail` key in the body.  An org id can be passed through which will create a linked Booking on the Org. Once this is set on a Booking via any of the Confirmation acceptances, it cannot be set again. time for any Confirm  The returned content will be a link to open the users SMS app with the recipient being the Confirmation owner and the content from the `booking_confirmation_accepted_sms` template.
         * @summary Accepts the Booking
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PublicConfirmationRecipientAcceptRequest} [publicConfirmationRecipientAcceptRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingConfirmationApproveCreate(recipientId: string, aaSource?: string, publicConfirmationRecipientAcceptRequest?: PublicConfirmationRecipientAcceptRequest, options?: any): AxiosPromise<ConfirmationAcceptedPublic> {
            return localVarFp.publicBookingConfirmationApproveCreate(recipientId, aaSource, publicConfirmationRecipientAcceptRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Declining a Confirmation can only occur when the Confirmation is the latest for the Booking and the status of the Confirmation is OPEN.  If theres any issue when accepting the Confirmation the message for why will be returned in the `detail` key in the body.
         * @summary Declines the Booking
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingConfirmationDeclineCreate(recipientId: string, aaSource?: string, options?: any): AxiosPromise<ConfirmationRecipientPublic> {
            return localVarFp.publicBookingConfirmationDeclineCreate(recipientId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads media against the Confirmation
         * @param {string} recipientId 
         * @param {ConfirmationPublicCreateMediaRequest} confirmationPublicCreateMediaRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingConfirmationMediaCreate(recipientId: string, confirmationPublicCreateMediaRequest: ConfirmationPublicCreateMediaRequest, aaSource?: string, options?: any): AxiosPromise<ConfirmationPublicMediaRead> {
            return localVarFp.publicBookingConfirmationMediaCreate(recipientId, confirmationPublicCreateMediaRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates a signature to allow content to be uploaded to Cloudinary directly
         * @param {string} recipientId 
         * @param {ConfirmationPublicMediaSignatureRequest} confirmationPublicMediaSignatureRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingConfirmationMediaSignatureCreate(recipientId: string, confirmationPublicMediaSignatureRequest: ConfirmationPublicMediaSignatureRequest, aaSource?: string, options?: any): AxiosPromise<MediaSignature> {
            return localVarFp.publicBookingConfirmationMediaSignatureCreate(recipientId, confirmationPublicMediaSignatureRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * `settings.orgs` contains a list of Organisations the Contact is an APPROVED member of. These can be used to assign and Org to the Confirmation on acceptance. 
         * @summary Fetch the public information about the Booking Confirmation
         * @param {string} recipientId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicBookingConfirmationRetrieve(recipientId: string, aaSource?: string, options?: any): AxiosPromise<ConfirmationRecipientPublic> {
            return localVarFp.publicBookingConfirmationRetrieve(recipientId, aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for publicBookingConfirmationApproveCreate operation in PublicBookingConfirmationApi.
 * @export
 * @interface PublicBookingConfirmationApiPublicBookingConfirmationApproveCreateRequest
 */
export interface PublicBookingConfirmationApiPublicBookingConfirmationApproveCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicBookingConfirmationApiPublicBookingConfirmationApproveCreate
     */
    readonly recipientId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicBookingConfirmationApiPublicBookingConfirmationApproveCreate
     */
    readonly aaSource?: string

    /**
     * 
     * @type {PublicConfirmationRecipientAcceptRequest}
     * @memberof PublicBookingConfirmationApiPublicBookingConfirmationApproveCreate
     */
    readonly publicConfirmationRecipientAcceptRequest?: PublicConfirmationRecipientAcceptRequest
}

/**
 * Request parameters for publicBookingConfirmationDeclineCreate operation in PublicBookingConfirmationApi.
 * @export
 * @interface PublicBookingConfirmationApiPublicBookingConfirmationDeclineCreateRequest
 */
export interface PublicBookingConfirmationApiPublicBookingConfirmationDeclineCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicBookingConfirmationApiPublicBookingConfirmationDeclineCreate
     */
    readonly recipientId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicBookingConfirmationApiPublicBookingConfirmationDeclineCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for publicBookingConfirmationMediaCreate operation in PublicBookingConfirmationApi.
 * @export
 * @interface PublicBookingConfirmationApiPublicBookingConfirmationMediaCreateRequest
 */
export interface PublicBookingConfirmationApiPublicBookingConfirmationMediaCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicBookingConfirmationApiPublicBookingConfirmationMediaCreate
     */
    readonly recipientId: string

    /**
     * 
     * @type {ConfirmationPublicCreateMediaRequest}
     * @memberof PublicBookingConfirmationApiPublicBookingConfirmationMediaCreate
     */
    readonly confirmationPublicCreateMediaRequest: ConfirmationPublicCreateMediaRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicBookingConfirmationApiPublicBookingConfirmationMediaCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for publicBookingConfirmationMediaSignatureCreate operation in PublicBookingConfirmationApi.
 * @export
 * @interface PublicBookingConfirmationApiPublicBookingConfirmationMediaSignatureCreateRequest
 */
export interface PublicBookingConfirmationApiPublicBookingConfirmationMediaSignatureCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicBookingConfirmationApiPublicBookingConfirmationMediaSignatureCreate
     */
    readonly recipientId: string

    /**
     * 
     * @type {ConfirmationPublicMediaSignatureRequest}
     * @memberof PublicBookingConfirmationApiPublicBookingConfirmationMediaSignatureCreate
     */
    readonly confirmationPublicMediaSignatureRequest: ConfirmationPublicMediaSignatureRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicBookingConfirmationApiPublicBookingConfirmationMediaSignatureCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for publicBookingConfirmationRetrieve operation in PublicBookingConfirmationApi.
 * @export
 * @interface PublicBookingConfirmationApiPublicBookingConfirmationRetrieveRequest
 */
export interface PublicBookingConfirmationApiPublicBookingConfirmationRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicBookingConfirmationApiPublicBookingConfirmationRetrieve
     */
    readonly recipientId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicBookingConfirmationApiPublicBookingConfirmationRetrieve
     */
    readonly aaSource?: string
}

/**
 * PublicBookingConfirmationApi - object-oriented interface
 * @export
 * @class PublicBookingConfirmationApi
 * @extends {BaseAPI}
 */
export class PublicBookingConfirmationApi extends BaseAPI {
    /**
     * Acceptance can only occur when the Confirmation is the latest for the Booking and the status of the Confirmation is OPEN. If theres any issue when accepting the Confirmation the message for why will be returned in the `detail` key in the body.  An org id can be passed through which will create a linked Booking on the Org. Once this is set on a Booking via any of the Confirmation acceptances, it cannot be set again. time for any Confirm  The returned content will be a link to open the users SMS app with the recipient being the Confirmation owner and the content from the `booking_confirmation_accepted_sms` template.
     * @summary Accepts the Booking
     * @param {PublicBookingConfirmationApiPublicBookingConfirmationApproveCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicBookingConfirmationApi
     */
    public publicBookingConfirmationApproveCreate(requestParameters: PublicBookingConfirmationApiPublicBookingConfirmationApproveCreateRequest, options?: any) {
        return PublicBookingConfirmationApiFp(this.configuration).publicBookingConfirmationApproveCreate(requestParameters.recipientId, requestParameters.aaSource, requestParameters.publicConfirmationRecipientAcceptRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Declining a Confirmation can only occur when the Confirmation is the latest for the Booking and the status of the Confirmation is OPEN.  If theres any issue when accepting the Confirmation the message for why will be returned in the `detail` key in the body.
     * @summary Declines the Booking
     * @param {PublicBookingConfirmationApiPublicBookingConfirmationDeclineCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicBookingConfirmationApi
     */
    public publicBookingConfirmationDeclineCreate(requestParameters: PublicBookingConfirmationApiPublicBookingConfirmationDeclineCreateRequest, options?: any) {
        return PublicBookingConfirmationApiFp(this.configuration).publicBookingConfirmationDeclineCreate(requestParameters.recipientId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads media against the Confirmation
     * @param {PublicBookingConfirmationApiPublicBookingConfirmationMediaCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicBookingConfirmationApi
     */
    public publicBookingConfirmationMediaCreate(requestParameters: PublicBookingConfirmationApiPublicBookingConfirmationMediaCreateRequest, options?: any) {
        return PublicBookingConfirmationApiFp(this.configuration).publicBookingConfirmationMediaCreate(requestParameters.recipientId, requestParameters.confirmationPublicCreateMediaRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates a signature to allow content to be uploaded to Cloudinary directly
     * @param {PublicBookingConfirmationApiPublicBookingConfirmationMediaSignatureCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicBookingConfirmationApi
     */
    public publicBookingConfirmationMediaSignatureCreate(requestParameters: PublicBookingConfirmationApiPublicBookingConfirmationMediaSignatureCreateRequest, options?: any) {
        return PublicBookingConfirmationApiFp(this.configuration).publicBookingConfirmationMediaSignatureCreate(requestParameters.recipientId, requestParameters.confirmationPublicMediaSignatureRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * `settings.orgs` contains a list of Organisations the Contact is an APPROVED member of. These can be used to assign and Org to the Confirmation on acceptance. 
     * @summary Fetch the public information about the Booking Confirmation
     * @param {PublicBookingConfirmationApiPublicBookingConfirmationRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicBookingConfirmationApi
     */
    public publicBookingConfirmationRetrieve(requestParameters: PublicBookingConfirmationApiPublicBookingConfirmationRetrieveRequest, options?: any) {
        return PublicBookingConfirmationApiFp(this.configuration).publicBookingConfirmationRetrieve(requestParameters.recipientId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
